import { Grid, Typography } from "@mui/material";
import React, { Fragment, useEffect, useState } from "react";

import { Mandatory } from "../FormOne";
import { TextField } from "../../../../components";
import { colors } from "../../../css components/Style";
import { sentenceCase } from "change-case-all";

function Range({ counts, state, dispatch, field, editState, formikProps }) {
  const [input, setInput] = useState({});
  const [message, setMessage] = useState({});

  function handleMandate(name) {
    let value = false;
    let key = "mandatory";
    dispatch({
      type: "CALCULATE_PERCENTAGE",
      payload: { value, name, key },
    });
  }

  const handleFieldChange = (value, name, key) => {
    if (
      !input?.[field.name]?.value?.[field.options[0].value] &&
      !input[field.name]?.value?.[field.options[1].value]
    ) {
      let noRange = "empty";
      dispatch({
        type: "RANGE_UPDATE",
        payload: { value, name, key, noRange },
      });
      if (field.is_ioh_contributor) {
        handleMandate(name);
      }
    } else {
      dispatch({ type: "RANGE_UPDATE", payload: { value, name, key } });
      if (field.is_ioh_contributor) {
        let value = true;
        let key = "mandatory";
        dispatch({
          type: "CALCULATE_PERCENTAGE",
          payload: { value, name, key },
        });
      }
    }
  };

  useEffect(() => {
    if (state[field.name]) {
      setInput((prev) => ({
        ...prev,
        [field.name]: state[field.name],
      }));
    }
  }, [state, field.name]);

  function handleValueValidation(num1, num2 = 0, field, key) {
    let { min_default_val, max_default_val } = field;

    let numInt1 = parseInt(num1);
    let numInt2 = parseInt(num2);

    const newMessages = { ...message };
    const fieldMessages = newMessages[field.name] || {};
    let error = false;

    if ((num1 || num2) && (isNaN(num1) || isNaN(num2))) {
      fieldMessages[key] = sentenceCase("Please enter digits");
      error = true;
    }

    if (numInt1 && numInt2 && numInt1 > numInt2) {
      fieldMessages[key] = sentenceCase("Min should be less than max");
      error = true;
    }

    if (numInt1 < min_default_val || numInt1 > max_default_val) {
      fieldMessages[key] = sentenceCase(
        `Min should be between ${min_default_val} and ${max_default_val}.`
      );
      error = true;
    }

    if (numInt2 && (numInt2 < min_default_val || numInt2 > max_default_val)) {
      fieldMessages[key] = sentenceCase(
        `Max should be between ${min_default_val} and ${max_default_val}.`
      );
      error = true;
    }

    if (error) {
      newMessages[field.name] = fieldMessages;
    } else {
      delete newMessages[field.name];
    }

    setMessage(newMessages);
  }

  return (
    <Fragment>
      <Grid item xs={6}>
        <Grid container spacing={3}>
          <Grid item xs={12} style={{ paddingTop: "0px" }}>
            <Mandatory
              dispatch={dispatch}
              state={state}
              editState={editState}
              field={field}
              formikProps={formikProps}
            />
          </Grid>

          <Grid item xs={6} style={{ paddingTop: "0px" }}>
            <TextField
              value={input?.[field.name]?.value?.[field.options[0].value] || ""}
              size="small"
              onBlur={() => {
                handleFieldChange(
                  input[field.name]?.value?.[field.options[0].value],
                  field.name,
                  `${field.options[0].value}`
                );
              }}
              onChange={(e) => {
                const { value } = e.target;
                if (isNaN(value)) {
                  setMessage((prev) => ({
                    ...prev,
                    [field.name]: {
                      ...prev[field.name],
                      [field.options[0].value]: "Please enter a digit",
                    },
                  }));
                  return;
                }

                handleValueValidation(
                  value,
                  input?.[field.name]?.value?.[field.options[1].value],
                  field,
                  field.options[0].value
                );

                setInput((prev) => ({
                  ...prev,
                  [field.name]: {
                    value: {
                      ...input[field.name]?.value,
                      [field.options[0].value]: value,
                    },
                  },
                }));
              }}
              name={`${field.name}.value.${field.options[0].value}`}
              placeholder={field.options[0].label}
              disabled={!editState || (!field.is_ioh_contributor && counts < 2)}
            />
            <Typography color={colors.error} variant="caption">
              {message[field.name]?.[field.options[0].value]}
            </Typography>
          </Grid>

          {/* Second Value */}
          <Grid item xs={6} style={{ paddingTop: "0px" }}>
            <TextField
              size="small"
              value={input?.[field.name]?.value?.[field.options[1].value] || ""}
              onBlur={() => {
                handleFieldChange(
                  input[field.name]?.value?.[field.options[1].value],
                  field.name,
                  `${field.options[1].value}`
                );
              }}
              onChange={(e) => {
                const { value } = e.target;
                if (isNaN(value)) {
                  setMessage((prev) => ({
                    ...prev,
                    [field.name]: {
                      ...prev[field.name],
                      [field.options[1].value]: "Please enter a digit",
                    },
                  }));
                  return;
                }

                handleValueValidation(
                  input?.[field.name]?.value?.[field.options[0].value],
                  value,
                  field,
                  field.options[1].value
                );

                setInput((prev) => ({
                  ...prev,
                  [field.name]: {
                    value: {
                      ...input[field.name]?.value,
                      [field.options[1].value]: value,
                    },
                  },
                }));
              }}
              name={`${field.name}.value.${field.options[1].value}`}
              placeholder={field.options[1].label}
              disabled={!editState || (!field.is_ioh_contributor && counts < 2)}
            />
            <Typography color={colors.error} variant="caption">
              {message[field.name]?.[field.options[1].value]}
            </Typography>
          </Grid>
        </Grid>
      </Grid>
    </Fragment>
  );
}

export default Range;
